import { axiosBase } from "utils";

/* ---------------- Items (Parts / Services) ---------------- */
export function billingItemListService() {
  return axiosBase.create()({ method: "GET", url: "/billing-product" });
}
export function billingItemByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/billing-product/" + id });
}
export function billingItemCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/billing-product", data });
}
export function billingItemUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/billing-product/" + id, data });
}
export function billingItemDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/billing-product/" + id });
}

/* ---------------- Categories ---------------- */
export function billingCategoryListService() {
  return axiosBase.create()({ method: "GET", url: "/billing-category" });
}
export function billingCategoryByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/billing-category/" + id });
}
export function billingCategoryCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/billing-category", data });
}
export function billingCategoryUpdateService(id, data) {
  return axiosBase.create()({
    method: "PATCH",
    url: "/billing-category/" + id,
    data,
  });
}
export function billingCategoryDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/billing-category/" + id });
}

/* ---------------- Tax Rates ---------------- */
export function billingTaxRateListService() {
  return axiosBase.create()({ method: "GET", url: "/billing-tax-rate" });
}
export function billingTaxRateByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/billing-tax-rate/" + id });
}
export function billingTaxRateCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/billing-tax-rate", data });
}
export function billingTaxRateUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/billing-tax-rate/" + id, data });
}
export function billingTaxRateDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/billing-tax-rate/" + id });
}
export function billingTaxRateResolveService(state, productType) {
  return axiosBase.create()({
    method: "GET",
    url: `/billing-tax-rate/resolve?state=${encodeURIComponent(
      state || ""
    )}&product_type=${encodeURIComponent(productType || "")}`,
  });
}

/* ---------------- Settings ---------------- */
export function billingSettingsGetService() {
  return axiosBase.create()({ method: "GET", url: "/billing-settings" });
}
export function billingSettingsUpdateService(data) {
  return axiosBase.create()({ method: "PATCH", url: "/billing-settings", data });
}

/* ---------------- Invoices ---------------- */
export function billingInvoiceListService(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return axiosBase.create()({
    method: "GET",
    url: "/billing-invoice" + (qs ? "?" + qs : ""),
  });
}
export function billingInvoiceByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/billing-invoice/" + id });
}
export function billingInvoiceCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/billing-invoice", data });
}
export function billingInvoiceUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/billing-invoice/" + id, data });
}
export function billingInvoiceDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/billing-invoice/" + id });
}
export function billingInvoiceStatusService(id, status, sendEmail) {
  return axiosBase.create()({
    method: "PATCH",
    url: "/billing-invoice/" + id + "/status",
    data: { status, send_email: sendEmail },
  });
}
export function billingInvoiceNextNumberService() {
  return axiosBase.create()({
    method: "GET",
    url: "/billing-invoice/generate-invoice-number",
  });
}

/* ---------------- Payments ---------------- */
export function billingPaymentListService(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return axiosBase.create()({
    method: "GET",
    url: "/billing-payment" + (qs ? "?" + qs : ""),
  });
}
export function billingPaymentByInvoiceService(invoiceId) {
  return axiosBase.create()({
    method: "GET",
    url: "/billing-payment/invoice/" + invoiceId,
  });
}
export function billingPaymentCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/billing-payment", data });
}
export function billingPaymentDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/billing-payment/" + id });
}

/* ---------------- Recurring templates ---------------- */
export function billingRecurringListService(params = {}) {
  const qs = new URLSearchParams(params).toString();
  return axiosBase.create()({
    method: "GET",
    url: "/billing-recurring" + (qs ? "?" + qs : ""),
  });
}
export function billingRecurringByIdService(id) {
  return axiosBase.create()({ method: "GET", url: "/billing-recurring/" + id });
}
export function billingRecurringCreateService(data) {
  return axiosBase.create()({ method: "POST", url: "/billing-recurring", data });
}
export function billingRecurringUpdateService(id, data) {
  return axiosBase.create()({ method: "PATCH", url: "/billing-recurring/" + id, data });
}
export function billingRecurringDeleteService(id) {
  return axiosBase.create()({ method: "DELETE", url: "/billing-recurring/" + id });
}
export function billingRecurringGenerateService(id) {
  return axiosBase.create()({
    method: "POST",
    url: "/billing-recurring/" + id + "/generate",
  });
}
export function billingRecurringInvoicesService(id) {
  return axiosBase.create()({
    method: "GET",
    url: "/billing-recurring/" + id + "/invoices",
  });
}

/* ---------------- Meta (customers, sales agents) ---------------- */
export function billingCustomerListService() {
  return axiosBase.create()({ method: "GET", url: "/billing-meta/customers" });
}
export function billingCustomerDetailsService(id) {
  return axiosBase.create()({
    method: "GET",
    url: "/billing-meta/customers/" + id,
  });
}
export function billingSalesAgentListService() {
  return axiosBase.create()({
    method: "GET",
    url: "/billing-meta/sales-agents",
  });
}
